/**
 * PAGINATION TOKENS
 *
 * Custom additions are marked with "Custom" comments below.
 */
import { nbxVar as v } from '../../../tokens/generated/nbx-tokens.js';
import { SEMANTIC, type SemanticTokens } from '../semantic.js';

export function createPaginationTokens(s: SemanticTokens) {
  return {
    bgDefault: v('pagination.bg-default'), // --pagination-bg-default: var(--surface-ground)
    bgHover: v('pagination.bg-hover'), // --pagination-bg-hover: var(--surface-raised)
    bgPressed: v('pagination.bg-pressed'), // --pagination-bg-pressed: var(--color-rentsody-100)
    bgActive: s.surface.ground, // --pagination-bg-active: var(--surface-ground)
    bgDisabled: v('pagination.bg-disabled'), // --pagination-bg-disabled: var(--color-neutral-200)
    fgDefault: v('pagination.fg-default'), // --pagination-fg-default: var(--text-secondary)
    fgHover: v('pagination.fg-hover'), // --pagination-fg-hover: var(--text-secondary)
    fgActive: s.text.onColor, // --pagination-fg-active: var(--text-on-color)
    fgDisabled: v('pagination.fg-disabled'), // --pagination-fg-disabled: var(--text-on-color)

    // ──── Custom tokens ────

    shadow: v('shadow.pagination'), // --pagination-shadow
    base: {
      fontWeight: s.typography.fontWeight.bold, // --pagination-base-font-weight
      gap: s.layout.gap.lg, // --pagination-base-gap (1.5rem)
      buttonSize: s.controlSize.md, // --pagination-base-button-size (2.75rem)
      radius: s.radius.md, // --pagination-base-radius
      iconSize: s.iconSizes.lg, // --pagination-base-icon-size
    },
  };
}
export const paginationTokens = createPaginationTokens(SEMANTIC);
